import React from "react";
import { type TextProps } from "../model";
import "./styles.scss";
import { type KC_Weights } from "../../ds_commons";

interface KC_UISmallProps extends TextProps {
  weight: KC_Weights;
}
export default function KC_UISmall(props: KC_UISmallProps) {
  return (
    <small
      className={`kc-ui-small ui-text-sm-${props.weight} ${props.className ? props.className : ""}`}
    >
      {props.text}
    </small>
  );
}
